var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-progress"},[_c('b-progress',[_c('b-progress-bar',{style:(_vm.progressStyle),attrs:{"value":_vm.progressValue,"label-html":_vm.progressLabel}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }